<template>
<footer>
	<div class="ftWrap">
		<div class="sns">
			<a href="https://www.facebook.com/BMWKorea"   target="_blank" title="새창 열림" class="fb">Facebook</a>
			<a href="https://www.instagram.com/bmw_korea" target="_blank" title="새창 열림" class="insta">Instagram</a>
		</div>
		<div class="linkWrap">
			<a @click="$router.push(`/termInfo/${ConstTerms.SERVICE_AGREEMENT}`)">{{ConstTerms.getTermsTitle()[ConstTerms.SERVICE_AGREEMENT]}}</a>
			<!-- <a @click="$router.push(`/termInfo/${ConstTerms.PERSONAL_INFO}`)">개인정보처리방침</a> -->
			<a 
				@click="$router.push(`/termInfo/${ConstTerms.INSURANCE}`)">
				{{ConstTerms.getTermsTitle()[ConstTerms.INSURANCE]}}
			</a>
			<p style="text-align: left; font-size:10px; width:230px; line-height:18px;">
				“{{$store.state.msg_}}”
			</p>
		</div>
		<p class="copy">&copy; BMW Group Korea All rights reserved.</p>
	</div>
	<a @click="moveTop" class="btnTop" style="bottom:55px;"></a><!-- 전체 페이지에 동일하게 적용 -->
</footer>
</template>


<script>
import ConstTerms from "../helpers/ConstTerms";
export default {
	data() {
		return {
			ConstTerms,
		}
	},
	computed: {
		isPkgInInsurance() {
			const pkgs = this.$store.state.pkgs;
			let chkInsurance = false;

			for(const key in pkgs) {
				if(pkgs[key].group === 'POWER TRAIN') {
					chkInsurance = true;
					break;
				}
			}

			return chkInsurance;
		}
	},
	methods: {
		moveTop(){
			window.scrollTo(0,0)
			document.body.scrollTop = 0;
		}
	}
}
</script>